import { useEffect } from 'react';

export const useResizeEffect = (onResize: () => void, deps = []) => {
  useEffect(() => {
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, [...deps, onResize]);
};
